<template>
  <v-card style="height: 100%;">
      <v-container v-if="listLoad" fluid class="pa-5">
        <v-skeleton-loader  type="list-item-avatar"></v-skeleton-loader>
        <v-skeleton-loader  type="list-item-avatar"></v-skeleton-loader>
        <v-skeleton-loader  type="list-item-avatar"></v-skeleton-loader>
      </v-container>
      <v-container v-if="!listLoad" fluid class="pa-5">
        <span id="sector-expo">Top 10 Sectors</span>
        <div class="mt-5">
          <v-row style="height: 50px;" v-for="item in items.slice(0,10)" :key="item.id">
            <v-spacer>
            </v-spacer>
            <v-col cols="5">
              <p>{{ item.sector }}</p>
            </v-col>
            <v-col cols="1">
              <expo-distribution :title="item.sector + ' Distribution'" :expo="item.id" :type="'sector'" :investor="investor"></expo-distribution>
            </v-col>          
            <v-col cols="6">
              <v-progress-linear
                :value="item.weight"
                height="20"
                reactive                
              >
                <strong>{{ item.weight }}%</strong>
              </v-progress-linear>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-card>
</template>


<script>
  export default {
    name: 'InvestorAnalyzeComponentSectorExpo',
    props: ['investor'],   
    components: {
      ExpoDistribution: () => import('@/views/dashboard/components/investors/analyze/ExpoDistribution'),
    },          
    data() {
      return {
        items: [
        ],
        listLoad: true,
        errorbar: false,        
      }
    },
    mounted () {
      this.getListFromApi()
    },    
    methods: {            
      async getListFromApi() {
        var self = this
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        this.$http.get(process.env.VUE_APP_API_HOST + '/get-investor-portfolio-sector-expo/' + self.investor,{
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          //console.log(response.data)
          self.items = response.data 
          self.listLoad = false
        }).catch(function (/*error*/) {
          //console.log(error)
          self.listLoad = false
          //self.errorbar = true
        })
      }
    },
  }
</script>

